/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_MsInputs */

const en_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const es_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const de_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const zh_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const ar_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const fr_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const vi_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const sw_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const th_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const bs_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const ja_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const ko_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const pt_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const it_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const sv_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const nl_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const da_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const nb_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const fi_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const pl_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const ru_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const tr_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const hi_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const id_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const ms_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const cs_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const el_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const he_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const af_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

const hu_nav_language_ms = /** @type {(inputs: Nav_Language_MsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Melayu`)
};

/**
* | output |
* | --- |
* | "Bahasa Melayu" |
*
* @param {Nav_Language_MsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_ms = /** @type {((inputs?: Nav_Language_MsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_MsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_ms(inputs)
	if (locale === "de") return de_nav_language_ms(inputs)
	if (locale === "zh") return zh_nav_language_ms(inputs)
	if (locale === "ar") return ar_nav_language_ms(inputs)
	if (locale === "fr") return fr_nav_language_ms(inputs)
	if (locale === "vi") return vi_nav_language_ms(inputs)
	if (locale === "sw") return sw_nav_language_ms(inputs)
	if (locale === "th") return th_nav_language_ms(inputs)
	if (locale === "bs") return bs_nav_language_ms(inputs)
	if (locale === "ja") return ja_nav_language_ms(inputs)
	if (locale === "ko") return ko_nav_language_ms(inputs)
	if (locale === "pt") return pt_nav_language_ms(inputs)
	if (locale === "it") return it_nav_language_ms(inputs)
	if (locale === "sv") return sv_nav_language_ms(inputs)
	if (locale === "nl") return nl_nav_language_ms(inputs)
	if (locale === "da") return da_nav_language_ms(inputs)
	if (locale === "nb") return nb_nav_language_ms(inputs)
	if (locale === "fi") return fi_nav_language_ms(inputs)
	if (locale === "pl") return pl_nav_language_ms(inputs)
	if (locale === "ru") return ru_nav_language_ms(inputs)
	if (locale === "tr") return tr_nav_language_ms(inputs)
	if (locale === "hi") return hi_nav_language_ms(inputs)
	if (locale === "id") return id_nav_language_ms(inputs)
	if (locale === "ms") return ms_nav_language_ms(inputs)
	if (locale === "cs") return cs_nav_language_ms(inputs)
	if (locale === "el") return el_nav_language_ms(inputs)
	if (locale === "he") return he_nav_language_ms(inputs)
	if (locale === "af") return af_nav_language_ms(inputs)
	if (locale === "hu") return hu_nav_language_ms(inputs)
	return en_nav_language_ms(inputs)
});